import { useOrganizations } from '@sbu/hooks.organizations';
import { UserPrivilege, useUserPrivileges } from '@sbu/hooks.userprivileges';

import { useAppInfoQuery } from 'app/AppInfoQuery';

export const useChildOrganizations = () => {
  const { data: appInfoData, loading: isLoadingAppInfo } = useAppInfoQuery();

  const isFederatedCluster = appInfoData?.isFederatedCluster ?? false;
  const emailId = appInfoData?.currentUser?.email ?? '';
  const parentDeploymentId = appInfoData?.deployment ?? '';

  const { data, isLoading: isLoadingUserPrivileges } = useUserPrivileges([
    UserPrivilege.ViewOrganizationsAccess,
  ]);

  const canViewOrganizations: boolean = data?.hasAll || false;

  const { data: organizationsData, isLoading: isLoadingOrganizations } =
    useOrganizations(
      {
        emailId,
        parentDeploymentId,
      },
      {
        enabled:
          isFederatedCluster &&
          canViewOrganizations &&
          !!(emailId && parentDeploymentId),
        meta: {
          notifyErrors: false,
          logErrors: true,
        },
      }
    );

  return {
    data: organizationsData,
    loading:
      isLoadingUserPrivileges || isLoadingAppInfo || isLoadingOrganizations,
  };
};
